import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store.js'

import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'babel-polyfill'

// Force devtools if not production
if (process.env.DEPLOYMENT_ENV !== 'prod'){
  Vue.config.devtools = true;
}

Vue.use(BootstrapVue);

// import aruba from './js/aruba.js'
// Object.defineProperty(Vue.prototype, '$aruba', {value: aruba()});

import axios from 'axios'
const axiosInstance = axios.create({
  baseURL: 'http://localhost:5000'
});
//
Object.defineProperty(Vue.prototype, '$axios', { value: axios });

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faUser,
  faExclamationTriangle,
  faCheck,
  faTimesCircle,
  faCheckCircle,
  faDotCircle,
  faCircle,
  faInfoCircle,
  faAdjust,
  faWindowClose,
  faEdit,
  faSave,
  faCopy,
  faPaste,
  faFolderOpen,
  faShareAlt,
  faTrashAlt,
  faCaretRight,
  faCaretDown,
  faPlusCircle
} from '@fortawesome/pro-regular-svg-icons'

library.add(
  faUser,
  faExclamationTriangle,
  faCheck,
  faCheckCircle,
  faTimesCircle,
  faDotCircle,
  faCircle,
  faInfoCircle,
  faAdjust,
  faWindowClose,
  faEdit,
  faSave,
  faCopy,
  faPaste,
  faFolderOpen,
  faShareAlt,
  faTrashAlt,
  faCaretRight,
  faCaretDown,
  faPlusCircle
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// Vue setup
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
